module.exports = __webpack_public_path__ + "static/media/vegetable.911d427f.png";